/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 * Table column styled components
 *
 * @author Yakov Gushchin
 * @author Evgenij Tyan
 * @author Aleksandr Perkhunov
 * @author Anton Panasenko
 * @version 1.3.0
 * @since 1.0.0
 */

import styled from 'styled-components';

import { colors } from '../../../../../theme';
import { ImgStyled } from '../../../../common/Block/Img';

export const CellStyled = styled.div`
    flex-basis: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    &.right {
        text-align: right;
        & span {
            text-align: right;
        }
    }

    & .block-with-icon .text-block {
        line-height: 1;
    }

    .table-text-block--currency {
        padding-left: 4px;
    }

    & > div:not(:last-child) {
        margin-bottom: 4px;
    }
`;
export const CheckboxFilterStyled = styled.div`
    margin: 6px;
`;
export const CheckboxTableStyled = styled.div`
    margin: 2px 6px;
`;

export const TableStatusBlockContainerStyled = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 24px;

    & ${ImgStyled} {
        margin-right: 4px;
    }
`;

export const TableExpandButtonStyled = styled.div`
    position: relative;
    transition: 0.5s ease-out;
    width: 20px;
    height: 20px;
    margin: 2px;
    box-sizing: border-box;
    border-radius: 2px;
    border: solid 2px ${colors.tableExpandButtonBorderColor};
    cursor: pointer;

    :hover {
        border-color: ${colors.tableExpandButtonHoverBorderColor};
    }

    .horizontal-line {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 10px;
        height: 2px;
        background-color: ${colors.tableExpandButtonLineColor};
    }
    .vertical-line {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 2px;
        height: 10px;
        background-color: ${colors.tableExpandButtonLineColor};
    }
    &.minus {
        .vertical-line {
            display: none;
        }
    }
`;
